/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandy_Keen_Goose_StirInputs */

const en_sandy_keen_goose_stir = /** @type {(inputs: Sandy_Keen_Goose_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Below minimum threshold`)
};

const de_sandy_keen_goose_stir = /** @type {(inputs: Sandy_Keen_Goose_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unter Schwellenwert`)
};

/**
* | output |
* | --- |
* | "Below minimum threshold" |
*
* @param {Sandy_Keen_Goose_StirInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sandy_keen_goose_stir = /** @type {((inputs?: Sandy_Keen_Goose_StirInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandy_Keen_Goose_StirInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sandy_keen_goose_stir(inputs)
	return de_sandy_keen_goose_stir(inputs)
});